import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { environment } from '@kuiper/ibusiness-core';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// `npm start` also builds `development`: keep local dev servers out of Sentry
if (environment.sentry.enabled && location.hostname !== 'localhost') {
  Sentry.init(environment.sentry.configs);
}

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
